<template>
  <div>
    <div id="header" :class="styleFunc ? 'home-header' : 'header'" v-if="is_pc">
      <div class="content">
        <img v-if="styleFunc" @click="$router.push('/')" class="logo" src="../../static/img/logo.png" alt="" />
        <!-- <img v-else @click="$router.push('/')" class="logo" src="https://pics.usho.cn/20240914/1726280052.jpg" alt="" /> -->
        <img v-else @click="$router.push('/')" class="logo" src="https://pics.usho.cn/20241014/1728870700.png" alt="" />
        <!-- https://album.usho.cn/www/upload/53d71b1c387b822bd85eb06572181d17.png?imageView2/1/q/40 -->
        <!-- :class="{ 'is-home': isHome && !scroll }" -->
        <div>
          <div class="menu" v-for="(menu, index) in menus" :key="index" :class="{ 'active-menu': isActive(menu.copyPath) }">
            <template v-if="menu.name != '帮助中心'">
              <div :class="styleFunc ? 'menu-text' : 'menu-title'" @click="$router.replace(menu.path)">
                {{ menu.name }}
              </div>
              <div class="line"></div>
            </template>
            <template v-else>
              <div class="menu-title">
                <a :href="menu.path" target="_blank" rel="noopener noreferrer">{{ menu.name }}</a>
              </div>
            </template>
          </div>
        </div>
        <div class="option">
          <div class="login" :class="{ 'is-home': isHome && !scroll }" @click="goPW">
            登录
          </div>
          <!-- <div
          class="register"
          :class="{ 'register-is-home': isHome && !scroll }"
          @click="dialogClick('留言信息')"
        >
          获取方案
        </div> -->
        </div>
      </div>
      <vServicechat ref="child" v-if="showdialog" />
    </div>
    <div class="h5_header" v-else>
      <img class="system_logo" src="https://pics.usho.cn/20241011/1728610724.png" alt="">
      <div class="login_box">
        <div class="goPW" @click="goPW">登录</div>
        <img @click="mobileMenuShow = true" v-show="!mobileMenuShow" src="https://pics.usho.cn/20241011/1728610720.png" alt="">
        <img @click="mobileMenuShow = false" v-show="mobileMenuShow" src="https://pics.usho.cn/20241011/1728616441.png" alt="">
      </div>
      <div class="c_item_box" v-show="mobileMenuShow">
        <div @click="$router.push(it.path);mobileMenuShow = false;" v-for="it in menus" :key="it.name">{{ it.name }}</div>
      </div>
      <div class="c_opacity" @click="mobileMenuShow = false" v-show="mobileMenuShow"></div>
    </div>
  </div>

</template>
<script>
import vServicechat from "@/components/v-servicechat";
export default {
  components: {
    vServicechat,
  },
  data() {
    return {
      // { name: "价格", path: "/price" },
      // { name: "ENGLISH", path: "/english" },
      menus: [
        { name: "首页", path: "/", copyPath: "/" },
        { name: "产品介绍", path: "/product?title=产品介绍&aid=1053&vid=1081", copyPath: "/product" },
        // { name: "新媒体", path: "/media" },
        { name: "用户案例", path: "/partner?title=用户案例&aid=1054&vid=1082", copyPath: "/partner" },
        { name: "新闻热点", path: "/hotspot", copyPath: "/hotspot" },
        // { name: "社汇新闻", path: "/news" },
        { name: "公司简介", path: "/about", copyPath: "/about" },
        // { name: "帮助中心", path: "http://help.sosho.cn/index?category_id=126" },
      ],
      scroll: false,
      showdialog: false,
      is_pc: true,
      mobileMenuShow: false
    };
  },
  created() {
    this.isMobile();
  },
  computed: {
    isActive() {
      return (path) => path === this.$route.path;

    },
    isHome() {
      return this.$route.path == "/";
    },
    styleFunc() {
      return this.isHome && !this.scroll;
    },
  },
  mounted() {
    if (this.$route.path == "/") {
      window.addEventListener(
        "scroll",
        () => {
          let scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop;
          if (scrollTop > 60) {
            this.scroll = true;
          } else {
            this.scroll = false;
          }
        },
        true
      );
    }
  },
  methods: {
    goPW() {
      window.open("https://admin.sosho.cn/#/personal");
    },
    dialogClick(title) {
      this.showdialog = true;
      this.$nextTick(() => {
        this.$refs.child.xcxClick(title);
      })
    },
    isMobile() {
			var system = { win: false, mac: false, xll: false };
			var p = navigator.platform;
			system.win = p.indexOf("Win") == 0;
			system.mac = p.indexOf("Mac") == 0;
			system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
			if (system.win || system.mac || system.xll) {
				this.is_pc = true;
			} else {
				this.is_pc = false;
			}
		}
  },
};
</script>

<style scoped>

.h5_header {
  width: 100%;
  height: 5.02rem;
  display: flex;
  padding: 0.7rem 1.15rem 0.8rem 0.65rem;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(169,177,177,0.5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  .c_item_box {
    width: 100%;
    height: 15.93rem;
    position: absolute;
    top: 5.02rem;
    left: 0;
    z-index: -1;
    background: #fff;
    padding: 1.72rem 1.72rem 1.29rem 1.72rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    transition: all 0.5s;

    div {
      font-weight: 500;
      font-size: 1rem;
      color: rgba(0,0,0,0.8);
      text-decoration: none;
      margin-bottom: 1.43rem;
    }
  }

  .system_logo {
    width: 11.62rem;
    height: 2.87rem;
  }

  .login_box {
    display: flex;
    align-items: center;
    width: 8.53rem;

    .goPW {
      width: 5.45rem;
      height: 2.73rem;
      background: #31CEC2;
      border-radius: 0.29rem;
      font-weight: 500;
      font-size: 1rem;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      line-height: 2.73rem;
      float: left;
    }

    img {
      width: 1.72rem;
      height: 1.72rem;
      margin-left: 0.86rem;
      float: right;
      margin-top: 0.505rem;
    }
  }
}

#header {
  width: 100%;
  height: 96px;
  position: absolute;
  top: 0;
  /* background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.1) 100%
  ); */
  /* box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.25); */
}

.header {
  background: #fff;
  /* background-color: #ffffff; */
  /* box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.04); */
}

.content {
  width: 100%;
  height: 96px;
  /* margin: 0 auto; */
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.logo {
  width: 177px;
  height: 44px;
  /* margin-top: 14px; */
  float: left;
  /* margin-right: 80px; */
  cursor: pointer;
}

.menu {
  float: left;
  height: 100%;
  padding-top: 4px;
  text-align: center;
  box-sizing: border-box;
  position: relative;
}

.menu-text {
  font-size: 16px;

  font-weight: 400;
  /* color: rgba(0, 0, 0, 0.85); */
  color: #ffffff;
  padding: 0 20px;
  cursor: pointer;
}

.menu-title {
  font-size: 16px;

  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  padding: 0 20px;
  cursor: pointer;
}

.menu-title a {
  color: rgba(0, 0, 0, 0.85);
  text-decoration-line: none;

}

.active-menu .menu-text {
  font-weight: 500;
}

.active-menu .line {
  width: 100%;
  position: absolute;
  height: 3px;
  background: #31cec2;
  border-radius: 2px;
  bottom: -4px;
}

.option {
  /* margin-top: 10px;
  float: right; */
}

.login {
  display: inline-block;
  height: 24px;
  font-size: 16px;

  font-weight: 600;
  color: #31cec2;
  line-height: 24px;
  margin-right: 24px;
  cursor: pointer;
}

.is-home {
  color: #ffffff;
}

.register {
  display: inline-block;
  width: 112px;
  height: 44px;
  background: #31cec2;
  border-radius: 8px;
  font-size: 16px;

  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 44px;
  cursor: pointer;
}

.register:hover {
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
}

.register-is-home {
  color: #31cec2;
  background-color: #ffffff;
}

.home-header {
  background: linear-gradient(180deg,
      rgba(0, 0, 0, 0.4) 0%,
      rgba(0, 0, 0, 0.1) 100%);
  box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.25);
}

.c_opacity {
  width: 100%;
  height: 100vh;
  background: #333;
  opacity: 0.65;
  position: fixed;
  left: 0;
  top: 0;
  z-index: -2;
}
</style>



// WEBPACK FOOTER //
// src/components/v-header.vue